export default __webpack_public_path__ + "static/media/submissionSuccess.c51ef4ef.svg";